/** @returns {{ paybackYears: number }|null} null si aucune économie nette annuelle (pas de retour possible). */
export const computePayback = (annualSavings, capexTotal) => {
  if (annualSavings <= 0) return null;
  return { paybackYears: capexTotal / annualSavings };
};
